import { render, staticRenderFns } from "./WebPhone.vue?vue&type=template&id=4811e464&scoped=true&"
import script from "./WebPhone.vue?vue&type=script&lang=js&"
export * from "./WebPhone.vue?vue&type=script&lang=js&"
import style0 from "./WebPhone.vue?vue&type=style&index=0&id=4811e464&lang=scss&scoped=true&"
import style1 from "./WebPhone.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4811e464",
  null
  
)

component.options.__file = "WebPhone.vue"
export default component.exports